const DocMenuConfig = [
    {
        pages: [
            {
                heading: "dashboard.title",
                description: "dashboard.description",
                route: "/dashboard",
                fontIcon: "ki-element-11",
            },
        ],
    },
    {
        heading: "ecommerce.title",
        description: "ecommerce.description",
        route: "/ecommerce",
        pages: [
            {
                sectionTitle: "ecommerce.product.title",
                description: "ecommerce.product.description",
                route: "/ecommerce/products",
                fontIcon: "ki-lots-shopping",
                sub: [
                    {
                        heading: "ecommerce.product.list.title",
                        description: "ecommerce.product.list.description",
                        route: "/ecommerce/products/list", permission: "ecommerce/product",
                        fontIcon: "ki-package",
                    },
                    {
                        sectionTitle: "ecommerce.product.collation.title",
                        description: "ecommerce.product.collation.description",
                        route: "/ecommerce/products/collation",
                        fontIcon: "ki-setting-2",
                        sub: [
                            {
                                heading: "ecommerce.product.collation.category.title",
                                description: "ecommerce.product.collation.category.description",
                                route: "/ecommerce/products/collation/categories",
                                permission: "ecommerce/product/category",
                                fontIcon: "ki-category",
                            },
                            {
                                heading: "ecommerce.product.collation.brand.title",
                                description: "ecommerce.product.collation.brand.description",
                                route: "/ecommerce/products/collation/brands", permission: "ecommerce/product/brand",
                                fontIcon: "ki-tag",
                            },
                            {
                                heading: "ecommerce.product.collation.variant_types.title",
                                description: "ecommerce.product.collation.variant_types.description",
                                route: "/ecommerce/products/collation/variant-types",
                                permission: "ecommerce/product/variant/group",
                                fontIcon: "ki-element-plus",
                            },
                            {
                                heading: "ecommerce.product.collation.product_groups.title",
                                description: "ecommerce.product.collation.product_groups.description",
                                route: "/ecommerce/products/collation/product-groups",
                                permission: "ecommerce/product/group",
                                fontIcon: "ki-abstract-41",
                            },
                            {
                                heading: "ecommerce.product.collation.suppliers.title",
                                description: "ecommerce.product.collation.suppliers.description",
                                route: "/ecommerce/products/collation/suppliers",
                                permission: "ecommerce/product/supplier",
                                fontIcon: "ki-delivery",
                            },
                            {
                                heading: "ecommerce.product.collation.tags.title",
                                description: "ecommerce.product.collation.tags.description",
                                route: "/ecommerce/products/collation/tags",
                                fontIcon: "ki-price-tag",
                            },
                            {
                                heading: "ecommerce.product.collation.product_units.title",
                                description: "ecommerce.product.collation.product_units.description",
                                route: "/ecommerce/products/collation/product-units",
                                permission: "ecommerce/product/unit",
                                fontIcon: "ki-cheque",
                            },
                            {
                                heading: "ecommerce.product.collation.attribute.title",
                                description: "ecommerce.product.collation.attribute.description",
                                route: "/ecommerce/products/collation/attributes",
                                permission: "ecommerce/product/attribute/set",
                                fontIcon: "ki-abstract-41",
                            },
                        ],
                    },
                    {
                        heading: "ecommerce.product.priceList.title",
                        description: "ecommerce.product.priceList.description",
                        route: "/ecommerce/products/price-list", permission: "ecommerce/price-list",
                        fontIcon: "ki-dollar",
                    },
                    {
                        heading: "ecommerce.product.productBarcode.title",
                        description: "ecommerce.product.productBarcode.description",
                        route: "/ecommerce/products/product-barcode", permission: "ecommerce/product",
                        fontIcon: "ki-barcode",
                    },
                ],
            },
            {
                sectionTitle: "ecommerce.order.title",
                description: "ecommerce.order.description",
                route: "/ecommerce/order",
                fontIcon: "ki-handcart",
                sub: [
                    {
                        heading: "ecommerce.order.list.title",
                        description: "ecommerce.order.list.description",
                        route: "/ecommerce/order/list", permission: "ecommerce/order",
                        fontIcon: "ki-package",
                    },
                    {
                        heading: "ecommerce.order.drafts.title",
                        description: "ecommerce.order.drafts.description",
                        route: "/ecommerce/order/drafts", permission: "ecommerce/order-draft",
                        fontIcon: "ki-note",
                    },
                    {
                        heading: "ecommerce.order.abandonedCarts.title",
                        description: "ecommerce.order.abandonedCarts.description",
                        route: "/ecommerce/order/abandoned-carts", permission: "ecommerce/abandoned-cart",
                        fontIcon: "ki-trash",
                    },
                    {
                        heading: "ecommerce.order.cartLinks.title",
                        description: "ecommerce.order.cartLinks.description",
                        route: "/ecommerce/order/cart-links", permission: "ecommerce/cart-link",
                        fontIcon: "ki-share",
                    },
                    {
                        heading: "ecommerce.order.tags.title",
                        description: "ecommerce.order.tags.description",
                        route: "/ecommerce/order/tags",
                        fontIcon: "ki-price-tag",
                    },
                    {
                        heading: "ecommerce.order.giftCards.title",
                        description: "ecommerce.order.giftCards.description",
                        route: "/ecommerce/order/gift-cards", permission: "ecommerce/gift-card",
                        fontIcon: "ki-gift",
                    },
                    {
                        heading: "ecommerce.order.statuses.title",
                        description: "ecommerce.order.statuses.description",
                        route: "/ecommerce/order/statuses", permission: "ecommerce/order/status",
                        fontIcon: "ki-status",
                    },
                ],
            },
            {
                sectionTitle: "ecommerce.customer.title",
                description: "ecommerce.customer.description",
                route: "/ecommerce/customer",
                fontIcon: "ki-profile-circle",
                sub: [
                    {
                        heading: "ecommerce.customer.list.title",
                        description: "ecommerce.customer.list.description",
                        route: "/ecommerce/customer/list", permission: "user",
                        fontIcon: "ki-people",
                    },
                    {
                        heading: "ecommerce.customer.pendingApproval.title",
                        description: "ecommerce.customer.pendingApproval.description",
                        route: "/ecommerce/customer/pending-approval", permission: "user",
                        fontIcon: "ki-shield-tick",
                    },
                    {
                        heading: "ecommerce.customer.customerGroups.title",
                        description: "ecommerce.customer.customerGroups.description",
                        route: "/ecommerce/customer/customer-groups", permission: "user/customer-group",
                        fontIcon: "ki-profile-user",
                    },
                    {
                        heading: "ecommerce.customer.tags.title",
                        description: "ecommerce.customer.tags.description",
                        route: "/ecommerce/customer/tags",
                        fontIcon: "ki-price-tag",
                    },
                ],
            },
            {
                sectionTitle: "ecommerce.stock.title",
                description: "ecommerce.stock.description",
                route: "/ecommerce/stock",
                fontIcon: "ki-parcel",
                sub: [
                    {
                        heading: "ecommerce.stock.status.title",
                        description: "ecommerce.stock.status.description",
                        route: "/ecommerce/stock/status",
                        permission: "ecommerce/stock/status",
                        fontIcon: "ki-chart-simple",
                    },
                    {
                        heading: "ecommerce.stock.movements.title",
                        description: "ecommerce.stock.movements.description",
                        route: "/ecommerce/stock/movements",
                        permission: "ecommerce/stock/movement",
                        fontIcon: "ki-arrows-loop",
                    },
                    {
                        heading: "ecommerce.stock.purchases.title",
                        description: "ecommerce.stock.purchases.description",
                        route: "/ecommerce/stock/purchases",
                        permission: "ecommerce/stock/purchase",
                        fontIcon: "ki-purchase",
                    },
                    {
                        heading: "ecommerce.stock.transfers.title",
                        description: "ecommerce.stock.transfers.description",
                        route: "/ecommerce/stock/transfers",
                        permission: "ecommerce/stock/transfer",
                        fontIcon: "ki-arrow-two-diagonals",
                    },
                    {
                        heading: "ecommerce.stock.counts.title",
                        description: "ecommerce.stock.counts.description",
                        route: "/ecommerce/stock/counts",
                        permission: "ecommerce/stock/count",
                        fontIcon: "ki-questionnaire-tablet",
                    },
                    {
                        heading: "ecommerce.stock.warehouses.title",
                        description: "ecommerce.stock.warehouses.description",
                        route: "/ecommerce/stock/warehouses",
                        permission: "ecommerce/stock/warehouse",
                        fontIcon: "ki-delivery-3",
                    },
                ],
            },
            {
                heading: "ecommerce.report.title",
                description: "ecommerce.report.description",
                route: "/ecommerce/report",
                fontIcon: "ki-chart-simple",
            },
            {
                sectionTitle: "ecommerce.marketing.title",
                description: "ecommerce.marketing.description",
                route: "/ecommerce/marketing",
                fontIcon: "ki-laptop",
                sub: [
                    {
                        heading: "ecommerce.marketing.summary.title",
                        description: "ecommerce.marketing.summary.description",
                        route: "/ecommerce/marketing/summary",
                        fontIcon: "ki-chart-line",
                    },
                    {
                        heading: "ecommerce.marketing.emailSms.title",
                        description: "ecommerce.marketing.emailSms.description",
                        route: "/ecommerce/marketing/email-sms", permission: "ecommerce/marketing/campaign",
                        fontIcon: "ki-sms",
                    },
                    {
                        heading: "ecommerce.marketing.automation.title",
                        description: "ecommerce.marketing.automation.description",
                        route: "/ecommerce/marketing/automation", permission: "ecommerce/automation",
                        fontIcon: "ki-setting-3",
                    },
                    // Ortaklık Raporları: backend yok (ComingSoon iskelet) → canlıda gizli.
                    // Backend hazır olunca menüye geri açılır + permission eklenir.
                    // {
                    //     heading: "ecommerce.marketing.affiliateReports.title",
                    //     description: "ecommerce.marketing.affiliateReports.description",
                    //     route: "/ecommerce/marketing/affiliate-reports",
                    //     fontIcon: "ki-chart-pie-4",
                    // },
                ],
            },
            {
                sectionTitle: "ecommerce.discount.title",
                description: "ecommerce.discount.description",
                route: "/ecommerce/discount",
                fontIcon: "ki-discount",
                sub: [
                    {
                        heading: "ecommerce.discount.campaigns.title",
                        description: "ecommerce.discount.campaigns.description",
                        route: "/ecommerce/discount/campaigns", permission: "ecommerce/campaign",
                        fontIcon: "ki-ticket",
                    },
                    {
                        heading: "ecommerce.discount.couponCodes.title",
                        description: "ecommerce.discount.couponCodes.description",
                        route: "/ecommerce/discount/coupon-codes", permission: "ecommerce/discount-coupon",
                        fontIcon: "ki-code",
                    },
                    {
                        heading: "ecommerce.discount.campaignOffers.title",
                        description: "ecommerce.discount.campaignOffers.description",
                        route: "/ecommerce/discount/campaign-offers", permission: "ecommerce/product-offer",
                        fontIcon: "ki-gift",
                    },
                ],
            },
            {
                sectionTitle: "ecommerce.app.title",
                description: "ecommerce.app.description",
                route: "/ecommerce/app",
                fontIcon: "ki-abstract-39",
                sub: [
                    {
                        heading: "ecommerce.app.market.title",
                        description: "ecommerce.app.market.description",
                        route: "/ecommerce/app/market", permission: "ecommerce/app/installation",
                        fontIcon: "ki-shop",
                    },
                    {
                        heading: "ecommerce.app.myApps.title",
                        description: "ecommerce.app.myApps.description",
                        route: "/ecommerce/app/my-apps", permission: "ecommerce/app/installation",
                        fontIcon: "ki-element-8",
                    },
                    // Trendyol pazaryeri — uygulamaya özel ekranlar. Kendi
                    // sectionTitle'ı olduğu için sayfalar
                    // setTabsRouter('/ecommerce/app/trendyol') ile kendi sekme
                    // şeridini alır.
                    {
                        sectionTitle: "ecommerce.app.trendyol.title",
                        description: "ecommerce.app.trendyol.description",
                        route: "/ecommerce/app/trendyol",
                        fontIcon: "ki-shop",
                        sub: [
                            {
                                heading: "ecommerce.app.trendyol.dashboard",
                                description: "ecommerce.app.trendyol.dashboardDescription",
                                route: "/ecommerce/app/trendyol", permission: "ecommerce/app/trendyol/dashboard",
                                fontIcon: "ki-chart-line-up",
                            },
                            {
                                heading: "ecommerce.app.trendyol.products",
                                description: "ecommerce.app.trendyol.productsDescription",
                                route: "/ecommerce/app/trendyol/products", permission: "ecommerce/app/trendyol/product",
                                fontIcon: "ki-package",
                            },
                            {
                                heading: "ecommerce.app.trendyol.orders",
                                description: "ecommerce.app.trendyol.ordersDescription",
                                route: "/ecommerce/app/trendyol/orders", permission: "ecommerce/app/trendyol/order",
                                fontIcon: "ki-handcart",
                            },
                            {
                                heading: "ecommerce.app.trendyol.claims",
                                description: "ecommerce.app.trendyol.claimsDescription",
                                route: "/ecommerce/app/trendyol/claims", permission: "ecommerce/app/trendyol/claim",
                                fontIcon: "ki-arrow-two-diagonals",
                            },
                            {
                                heading: "ecommerce.app.trendyol.mapping",
                                description: "ecommerce.app.trendyol.mappingDescription",
                                route: "/ecommerce/app/trendyol/mapping", permission: "ecommerce/app/trendyol/mapping/category",
                                fontIcon: "ki-abstract-26",
                            },
                            {
                                heading: "ecommerce.app.trendyol.logs",
                                description: "ecommerce.app.trendyol.logsDescription",
                                route: "/ecommerce/app/trendyol/logs", permission: "ecommerce/app/trendyol/log",
                                fontIcon: "ki-code",
                            },
                            {
                                heading: "ecommerce.app.trendyol.settings",
                                description: "ecommerce.app.trendyol.settingsDescription",
                                route: "/ecommerce/app/trendyol/settings", permission: "ecommerce/app/trendyol/setting",
                                fontIcon: "ki-setting-2",
                            },
                        ],
                    },
                    // Ürün Kataloğu — Excel'den katalog + ürün eşleştirme (kendi sekme şeridi).
                    {
                        sectionTitle: "ecommerce.app.productCatalog.title",
                        description: "ecommerce.app.productCatalog.description",
                        route: "/ecommerce/app/product-catalog",
                        fontIcon: "ki-row-horizontal",
                        sub: [
                            {
                                heading: "ecommerce.app.productCatalog.catalogs",
                                description: "ecommerce.app.productCatalog.catalogsDescription",
                                route: "/ecommerce/app/product-catalog", permission: "ecommerce/app/product-catalog/catalog",
                                fontIcon: "ki-row-horizontal",
                            },
                        ],
                    },
                    // Shopier — iki yönlü ürün/sipariş + ödeme (kendi sekme şeridi).
                    {
                        sectionTitle: "ecommerce.app.shopier.title",
                        description: "ecommerce.app.shopier.description",
                        route: "/ecommerce/app/shopier",
                        fontIcon: "ki-handcart",
                        sub: [
                            {
                                heading: "ecommerce.app.shopier.dashboard",
                                description: "ecommerce.app.shopier.dashboardDescription",
                                route: "/ecommerce/app/shopier", permission: "ecommerce/app/shopier/dashboard",
                                fontIcon: "ki-chart-line-up",
                            },
                            {
                                heading: "ecommerce.app.shopier.products",
                                description: "ecommerce.app.shopier.productsDescription",
                                route: "/ecommerce/app/shopier/products", permission: "ecommerce/app/shopier/product",
                                fontIcon: "ki-package",
                            },
                            {
                                heading: "ecommerce.app.shopier.orders",
                                description: "ecommerce.app.shopier.ordersDescription",
                                route: "/ecommerce/app/shopier/orders", permission: "ecommerce/app/shopier/order",
                                fontIcon: "ki-handcart",
                            },
                            {
                                heading: "ecommerce.app.shopier.logs",
                                description: "ecommerce.app.shopier.logsDescription",
                                route: "/ecommerce/app/shopier/logs", permission: "ecommerce/app/shopier/log",
                                fontIcon: "ki-code",
                            },
                            {
                                heading: "ecommerce.app.shopier.settings",
                                description: "ecommerce.app.shopier.settingsDescription",
                                route: "/ecommerce/app/shopier/settings", permission: "ecommerce/app/shopier/setting",
                                fontIcon: "ki-setting-2",
                            },
                        ],
                    },
                ],
            },
            {
                heading: "ecommerce.salesChannels.title",
                description: "ecommerce.salesChannels.description",
                route: "/ecommerce/sales-channels", permission: "ecommerce/sales-channel",
                fontIcon: "ki-abstract-26",
            },
        ],
    },
    {
        heading: "site.title",
        description: "site.description",
        route: "/site-management",
        pages: [
            {
                sectionTitle: "site.administrators.title",
                description: "site.administrators.description",
                route: "/site-management/administrators",
                fontIcon: "ki-security-user",
                sub: [
                    {
                        heading: "site.administrators.admins.title",
                        description: "site.administrators.admins.description",
                        route: "/site-management/administrators/admins", permission: "admin",
                        fontIcon: "ki-user",
                    },
                    {
                        heading: "site.administrators.groups.title",
                        description: "site.administrators.groups.description",
                        route: "/site-management/administrators/groups", permission: "admin/group",
                        fontIcon: "ki-people",
                    },
                ],
            },
            {
                heading: "site.content.media.title",
                description: "site.content.media.description",
                action: "media-manager",
                permission: "file",
                fontIcon: "ki-folder",
            },
            {
                sectionTitle: "site.content.title",
                description: "site.content.description",
                route: "/site-management/content",
                fontIcon: "ki-note-2",
                sub: [
                    {
                        heading: "site.content.themes.title",
                        description: "site.content.themes.description",
                        route: "/site-management/content/themes", permission: "theme",
                        fontIcon: "ki-brush",
                    },
                    {
                        heading: "site.content.slider.title",
                        description: "site.content.slider.description",
                        route: "/site-management/content/slider", permission: "module/slider/group",
                        fontIcon: "ki-picture",
                    },
                    {
                        heading: "site.content.featured_products.title",
                        description: "site.content.featured_products.description",
                        route: "/site-management/content/featured-products", permission: "module/featured-product/group",
                        fontIcon: "ki-star",
                    },
                    {
                        sectionTitle: "site.content.blog.title",
                        description: "site.content.blog.description",
                        route: "/site-management/content/blog",
                        fontIcon: "ki-message-text-2",
                        sub: [
                            {
                                heading: "site.content.blog.posts.title",
                                description: "site.content.blog.posts.description",
                                route: "/site-management/content/blog/content", permission: "module/blog",
                                fontIcon: "ki-note-2",
                            },
                            {
                                heading: "site.content.blog.categories.title",
                                description: "site.content.blog.categories.description",
                                route: "/site-management/content/blog/categories", permission: "module/blog/category",
                                fontIcon: "ki-category",
                            },
                        ],
                    },
                    {
                        heading: "site.content.pages.title",
                        description: "site.content.pages.description",
                        route: "/site-management/content/pages", permission: "page",
                        fontIcon: "ki-document",
                    },
                    {
                        heading: "site.content.faq.title",
                        description: "site.content.faq.description",
                        route: "/site-management/content/faq", permission: "module/faq/group",
                        fontIcon: "ki-questionnaire-tablet",
                    },
                    {
                        heading: "site.content.forms.title",
                        description: "site.content.forms.description",
                        route: "/site-management/content/forms", permission: "module/form",
                        fontIcon: "ki-document",
                    },
                    {
                        heading: "site.content.popup.title",
                        description: "site.content.popup.description",
                        route: "/site-management/content/popup", permission: "module/popup",
                        fontIcon: "ki-screen",
                    },
                    {
                        heading: "site.content.links.title",
                        description: "site.content.links.description",
                        route: "/site-management/content/links", permission: "link/manager",
                        fontIcon: "ki-link",
                    },
                    {
                        heading: "site.content.sitemap.title",
                        description: "site.content.sitemap.description",
                        route: "/site-management/content/sitemap", permission: "seo/sitemap",
                        fontIcon: "ki-code",
                    },
                    {
                        heading: "site.content.menus.title",
                        description: "site.content.menus.description",
                        route: "/site-management/content/menus", permission: "menu",
                        fontIcon: "ki-abstract-26",
                    },
                ],
            },
            {
                sectionTitle: "site.localization.title",
                description: "site.localization.description",
                route: "/site-management/localization",
                fontIcon: "ki-geolocation",
                sub: [
                    {
                        heading: "site.localization.languages.title",
                        description: "site.localization.languages.description",
                        route: "/site-management/localization/languages", permission: "localization/language",
                        fontIcon: "ki-translate",
                    },
                    {
                        heading: "site.localization.currencies.title",
                        description: "site.localization.currencies.description",
                        route: "/site-management/localization/currencies", permission: "localization/currency",
                        fontIcon: "ki-dollar",
                    },
                    {
                        heading: "site.localization.taxes.title",
                        description: "site.localization.taxes.description",
                        route: "/site-management/localization/taxes", permission: "localization/tax",
                        fontIcon: "ki-percentage",
                    },
                    {
                        heading: "site.localization.countries.title",
                        description: "site.localization.countries.description",
                        route: "/site-management/localization/countries", permission: "localization/country",
                        fontIcon: "ki-geolocation",
                    },
                ],
            },
            {
                sectionTitle: "site.settings.title",
                description: "site.settings.description",
                route: "/site-management/settings",
                fontIcon: "ki-setting-2",
                sub: [
                    {
                        sectionTitle: "site.settings.general.title",
                        description: "site.settings.general.description",
                        route: "/site-management/settings/general",
                        fontIcon: "ki-setting-3",
                        sub: [
                            {
                                heading: "site.settings.site.title",
                                description: "site.settings.site.description",
                                route: "/site-management/settings/site", permission: "site/setting",
                                fontIcon: "ki-home-2",
                            },
                            {
                                heading: "site.settings.register.title",
                                description: "site.settings.register.description",
                                route: "/site-management/settings/register", permission: "system/setting",
                                fontIcon: "ki-user-tick",
                            },
                            {
                                heading: "site.settings.system_variables.title",
                                description: "site.settings.system_variables.description",
                                route: "/site-management/settings/system-variables", permission: "system/variable",
                                fontIcon: "ki-code",
                            },
                            {
                                heading: "site.settings.mail_templates.title",
                                description: "site.settings.mail_templates.description",
                                route: "/site-management/settings/mail-templates", permission: "site/setting",
                                fontIcon: "ki-sms",
                            },
                        ],
                    },
                    {
                        heading: "site.settings.tracking_codes.title",
                        description: "site.settings.tracking_codes.description",
                        route: "/site-management/settings/tracking-codes", permission: "module/tracking-code",
                        fontIcon: "ki-graph-up",
                    },
                    {
                        heading: "site.settings.media_providers.title",
                        description: "site.settings.media_providers.description",
                        route: "/site-management/settings/media-providers", permission: "stream/provider",
                        fontIcon: "ki-cloud",
                    },
                ],
            },
        ],
    },
];

export default DocMenuConfig;
